// Dependency
import React from "react";

// Styles
import * as loaderStyles from './loader-overlay.module.scss'

// Template
const Loader = ({active}) => {
    return (
        active ? 
        <div className={loaderStyles.cdLoaderOverlay}>
            <div className={loaderStyles.multiRipple}>
                <div></div>
                <div></div>
            </div>
        </div> : ''
    )
}

export default Loader
